var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import SafeHTML from "../utils/SafeHTML";
import getFieldLabel from "../Templates/utils/getFieldLabel";

import t from "../I18N/t";

export const ItemSnippet = ({ snippets, onSnippetClick, template }) => {
  let content;
  let source;
  if (snippets.metadata.length) {
    source = getFieldLabel(snippets.metadata[0].field, template);
    [content] = snippets.metadata[0].texts;
  } else {
    source = t('System', 'Document contents');
    content = snippets.fullText[0].text;
  }
  /* eslint-disable react/no-danger */
  const snippetElement = /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx("div", { className: "item-snippet-source" }, void 0, source), /*#__PURE__*/
  _jsx("div", { onClick: onSnippetClick, className: "item-snippet" }, void 0, /*#__PURE__*/
  _jsx(SafeHTML, {}, void 0, content)
  )
  );


  if (snippets.count === 1) {
    return /*#__PURE__*/_jsx("div", { className: "item-snippet-wrapper" }, void 0, snippetElement);
  }

  return /*#__PURE__*/(
    _jsx("div", { className: "item-snippet-wrapper" }, void 0,
    snippetElement, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("a", { onClick: onSnippetClick }, void 0, t('System', 'Show more'))
    )
    ));

};
















ItemSnippet.defaultProps = {
  onSnippetClick: undefined
};

export const mapStateToProps = (state, ownProps) => ({
  template: state.templates.find((tmpl) => tmpl.get('_id') === ownProps.doc.template)
});

export default connect(mapStateToProps)(ItemSnippet);